import { render, staticRenderFns } from "./DoneTask.vue?vue&type=template&id=42c3a487&scoped=true"
import script from "./DoneTask.vue?vue&type=script&lang=js"
export * from "./DoneTask.vue?vue&type=script&lang=js"
import style0 from "./DoneTask.vue?vue&type=style&index=0&id=42c3a487&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c3a487",
  null
  
)

export default component.exports